import * as z from 'zod';

import { booleanFormSchema, emailSchema, urlSchema } from '@/_schemas/generic';
import { statusFormSchema } from '@/_schemas/status-input';

import { brandQuerySchema } from './brand-query-schema';

export const brandFormSchema = brandQuerySchema
  .pick({
    id: true,
    logo: true,
    logo_light: true,
    icon: true,
    agreement_logo: true,
    phone_numbers: true,
    addresses: true,
    invoice_logo: true,
  })
  .extend({
    name: z.string().min(3),
    legal_name: z.string(),
    website: urlSchema(),
    email: emailSchema(),
    billing_email_address: emailSchema(),
    status: statusFormSchema,
    code: z.string(),
    agreement_statement: z.string(),
    invoice_disclaimer: z.string(),
    online_payment_url: urlSchema(),
    payable_to: z.string(),
    hide_online_payments: booleanFormSchema(),
  });

export type BrandFormSchema = z.infer<typeof brandFormSchema>;
